const Questions = [
{
    question: "1. Which of the following is the correct name of React.js?",
    answers: [
        {answer: "React" , isCorrect: false},
        {answer: "ReactJS" , isCorrect: false},
        {answer: "React.js" , isCorrect: false},
        {answer: "All of the above" , isCorrect: true},
    ],
},

{
    question: "2. Which of the following command is used to install create-react-app?",
    answers: [
        {answer: "npm install -g create-react-app" , isCorrect: true},
        {answer: "npm install create-react-app" , isCorrect: false},
        {answer: "npm install -f create-react-app" , isCorrect: false},
        {answer: "install -g create-react-app" , isCorrect: false},
    ],
},


{
    question: "3. What of the following is used in React.js to increase performance?",
    answers: [
        {answer: "Original DOM" , isCorrect: false},
        {answer: "Virtual DOM" , isCorrect: true},
        {answer: "Both A and B" , isCorrect: false},
        {answer: "None of the above" , isCorrect: false},
    ],
},


{
    question: "4. Which of the following acts as the input of a class-based component?",
    answers: [
        {answer: "Class" , isCorrect: false},
        {answer: "Factory" , isCorrect: false},
        {answer: "Render" , isCorrect: false},
        {answer: "Props" , isCorrect: true},
    ],
},

{
    question: "5. How many numbers of elements a valid react component can return",
    answers: [
        {answer: "1" , isCorrect: true},
        {answer: "2" , isCorrect: false},
        {answer: "4" , isCorrect: false},
        {answer: "5" , isCorrect: false},
    ],
},

]


export default Questions;